// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=testing` then `environment.testing.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
    apiVersion: '1',
    appName: 'TWESBDonorPortal',
    appVersion: '1.0.0',
    assetsPath: 'assets/',
    authClientId: 1,
    authSecretVariable: 'verysecret',
    baseApiUrl: '',
    calendlyInterviewAppointmentInPersonUrl: 'https://calendly.com/tweb/miles-tech-testing-inperson-tweb-disregard-clone',
    calendlyInterviewAppointmentZoomUrl: 'https://calendly.com/tweb/miles-tech-testing-tweb-disregard-clone',
    calendlyTestSampleAppointmentUrl: 'https://calendly.com/tweb/test-miles-tech-test-sample-appointment-clone',
    docPath: 'docs/',
    googleApiKey: '', // Empty this string to disable google login
    helloSignTestMode: true,
    imgPath: 'docs/images/',
    logger: false,
    msAuthConfig: null,
    production: false,
    siteName: 'TWESB Donor Portal',
    submitHelpUrl: 'http://submit-help.testing.milesapp.com',
};
